/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetProducts200ResponseItemsInnerSchedulesInnerDaysInner } from './GetProducts200ResponseItemsInnerSchedulesInnerDaysInner';
import {
    GetProducts200ResponseItemsInnerSchedulesInnerDaysInnerFromJSON,
    GetProducts200ResponseItemsInnerSchedulesInnerDaysInnerFromJSONTyped,
    GetProducts200ResponseItemsInnerSchedulesInnerDaysInnerToJSON,
    GetProducts200ResponseItemsInnerSchedulesInnerDaysInnerToJSONTyped,
} from './GetProducts200ResponseItemsInnerSchedulesInnerDaysInner';

/**
 * 
 * @export
 * @interface GetProducts200ResponseItemsInnerSchedulesInner
 */
export interface GetProducts200ResponseItemsInnerSchedulesInner {
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInnerSchedulesInner
     */
    id: string;
    /**
     * 
     * @type {Array<GetProducts200ResponseItemsInnerSchedulesInnerDaysInner>}
     * @memberof GetProducts200ResponseItemsInnerSchedulesInner
     */
    days: Array<GetProducts200ResponseItemsInnerSchedulesInnerDaysInner>;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInnerSchedulesInner
     */
    hourFrom: string;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInnerSchedulesInner
     */
    hourTo: string;
}

/**
 * Check if a given object implements the GetProducts200ResponseItemsInnerSchedulesInner interface.
 */
export function instanceOfGetProducts200ResponseItemsInnerSchedulesInner(value: object): value is GetProducts200ResponseItemsInnerSchedulesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('days' in value) || value['days'] === undefined) return false;
    if (!('hourFrom' in value) || value['hourFrom'] === undefined) return false;
    if (!('hourTo' in value) || value['hourTo'] === undefined) return false;
    return true;
}

export function GetProducts200ResponseItemsInnerSchedulesInnerFromJSON(json: any): GetProducts200ResponseItemsInnerSchedulesInner {
    return GetProducts200ResponseItemsInnerSchedulesInnerFromJSONTyped(json, false);
}

export function GetProducts200ResponseItemsInnerSchedulesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProducts200ResponseItemsInnerSchedulesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'days': ((json['days'] as Array<any>).map(GetProducts200ResponseItemsInnerSchedulesInnerDaysInnerFromJSON)),
        'hourFrom': json['hourFrom'],
        'hourTo': json['hourTo'],
    };
}

export function GetProducts200ResponseItemsInnerSchedulesInnerToJSON(json: any): GetProducts200ResponseItemsInnerSchedulesInner {
    return GetProducts200ResponseItemsInnerSchedulesInnerToJSONTyped(json, false);
}

export function GetProducts200ResponseItemsInnerSchedulesInnerToJSONTyped(value?: GetProducts200ResponseItemsInnerSchedulesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'days': ((value['days'] as Array<any>).map(GetProducts200ResponseItemsInnerSchedulesInnerDaysInnerToJSON)),
        'hourFrom': value['hourFrom'],
        'hourTo': value['hourTo'],
    };
}

